import React, { lazy } from 'react';
import { Navigate } from 'react-router-dom';
import { getIsQqDomain } from 'utils/common';
const Login = lazy(async () => await import('pages/Login'));
const Exception = lazy(async () => await import('pages/Exception'));
const Index = lazy(async () => await import('pages/Index'));
const CorpusProjectList = lazy(async () => await import('pages/Corpus/projectList'));
const CorpusMyTasks = lazy(async () => await import('pages/Corpus/myTasks'));
const CorpusReviewTasks = lazy(async () => await import('pages/Corpus/reviewTasks'));
const CorpusSamplingTasks = lazy(async () => await import('pages/Corpus/samplingTasks'));
const CorpusCheckTasks = lazy(async () => await import('pages/Corpus/checkTasks'));
const CorpusCheckedTasks = lazy(async () => await import('pages/Corpus/checkedTasks'));
const BotsCreate = lazy(async () => await import('pages/Corpus/createBots'));
const Iframe = lazy(async () => await import('pages/Iframe'));
const BotsIndex = lazy(async () => await import('pages/Corpus/botsList'));
const ROUTER_CONFIG = [
  {
    path: '/exception-403',
    element: <Exception type="403" />,
    meta: {
      white: true,
    },
  },
  {
    path: '/exception-404',
    element: <Exception type="404" />,
    meta: {
      white: true,
    },
  },
  {
    path: '/',
    element: <Navigate to={getIsQqDomain() ? '/corpus/my_tasks' : '/index'} />,
    meta: {
      white: true,
    },
  },
  {
    path: '/login',
    element: <Login />,
    meta: {
      white: true,
    },
  },
  {
    path: '/index',
    element: <Index />,
    meta: {
      white: true,
    },
  },
  {
    path: '/index/mydata',
    element: <Index />,
    meta: {
      white: true,
    },
  },
  {
    path: '/tool/account',
    element: <Index />,
    meta: {
      white: true,
    },
  },
  {
    path: '/tool/auth',
    element: <Exception type="403" />,
    meta: {
      white: true,
    },
  },
  {
    path: '/corpus/project_list',
    element: <CorpusProjectList />,
    meta: {
      white: true,
    },
  },
  {
    path: '/corpus/my_tasks',
    element: <CorpusMyTasks />,
    meta: {
      white: true,
    },
  },
  {
    path: '/corpus/review_tasks',
    element: <CorpusReviewTasks />,
    meta: {
      white: true,
    },
  },
  {
    path: '/corpus/sampling_tasks',
    element: <CorpusSamplingTasks />,
    meta: {
      white: true,
    },
  },
  {
    path: '/corpus/check_tasks',
    element: <CorpusCheckTasks />,
    meta: {
      white: true,
    },
  },
  {
    path: '/corpus/checked_tasks',
    element: <CorpusCheckedTasks />,
    meta: {
      white: true,
    },
  },
  {
    path: '/bots/index',
    element: <BotsIndex />,
    meta: {
      white: true,
    },
  },
  {
    path: '/bots/create',
    element: <BotsCreate />,
    meta: {
      white: true,
    },
  },
  {
    path: '/config/wuji/:path',
    element: <Iframe />,
    meta: {
      white: true,
    },
  },
  {
    path: '*',
    element: <Navigate to="/exception-404" />,
    meta: {
      white: true,
    },
  },
];

export default ROUTER_CONFIG;
